import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    addPackagingSlipsToStorage,
    getLocalPackagingSlipsForId,
    getPackagingSlips,
    PackagingSlip,
    PackagingSlipsParameter,
} from "@tKgpco/Services/CustomPackagingSlipsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type OnSuccess = {
    onSuccess?: (result: PackagingSlip[]) => void | PackagingSlip[] | undefined;
};

type OnError = {
    onError?: (result: PackagingSlip[]) => void | string | undefined;
};

type ParameterParam = PackagingSlipsParameter & OnSuccess & OnError;

type HandlerType = CustomApiHandler<ParameterParam, PackagingSlip[]>;

export const BeginLoadPackagingSlips: HandlerType = props => {
    props.dispatch({ type: "Custom/OrderHistoryPackagingSlips/BeginLoad" });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = getLocalPackagingSlipsForId(props.apiParameter.orderId) as PackagingSlip[];
        if (!props.apiResult) {
            props.apiResult = (await getPackagingSlips(props.apiParameter)) as unknown as PackagingSlip[];
            addPackagingSlipsToStorage(props.parameter.orderId, props.apiResult || []);
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadPackagingSlips: HandlerType = props => {
    props.dispatch({
        type: "Custom/OrderHistoryPackagingSlips/CompleteLoad",
        packagingSlips: props.apiResult,
    });
};

export const chain = [BeginLoadPackagingSlips, PopulateApiParameter, RequestDataFromApi, CompleteLoadPackagingSlips];

const getPackagingSlipsHandler = createHandlerChainRunner(chain, "GetPackagingSlips");
export default getPackagingSlipsHandler;
